<template>
    <div class="bottom-1">
            <el-dropdown @command="dropCommand" placement="bottom">
                <el-button class="bottom-1-span" size="mini" plain :style="{width: width,color:color, height: height, border: border, background:background, '--top':top, '--left':left, '--size':size}">
                    <div>
                        <i class="el-icon-sunrise"></i>
                        <span class="bottom-1-text" :style="{fontSize:fontsize}">操作</span>
                    </div>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  style="color:#303133;" command="4"><span style="font-size:14rem">{{dropdownText4}}</span></el-dropdown-item>
                    <el-dropdown-item  style="color:#303133;" command="5"><span style="font-size:14rem">{{dropdownText5}}</span></el-dropdown-item>
                    <el-dropdown-item  style="color:#0094FF;" command="1"><span style="font-size:14rem">{{dropdownText1}}</span></el-dropdown-item>
                    <el-dropdown-item  style="color:#FE1D1D;" command="2"><span style="font-size:14rem">{{dropdownText2}}</span></el-dropdown-item>
                    <el-dropdown-item  style="color:#FE1D1D;" command="3"><span style="font-size:14rem">{{dropdownText3}}</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
    </div>
</template>
<script>
    export default {
        name: 'popDrop',
        data() {
            return {
            }
        },
        props: {
            width: {
                type: String,
                default: '80rem',
            },
            height: {
                type: String,
                default: '30rem',
            },
            border: {
                type: String,
                default:'2rem',
            },
            background: {
                type: String,
                default: '#fff',
            },
            fontsize:{
               type: String, 
               default: '14rem',
            },
            color: {
                type: String,
                default: '#666666',
            },
            top:{
               type: String, 
               default: '0rem',
            },
            left:{
               type: String, 
               default: '0rem',
            },
            size:{
               type: String, 
               default: '0.45',
            },
            dropdownText1:{
               type: String, 
               default: '',
            },
            dropdownText2:{
               type: String, 
               default: '',
            },
            dropdownText3:{
               type: String, 
               default: '',
            },
            dropdownText4:{
               type: String, 
               default: '',
            },
            dropdownText5:{
               type: String, 
               default: '',
            }
        },
      
        methods: {
            dropCommand(command) {
                this.$emit('option', command)
            },
        }
    }
</script>
<style lang="scss" scoped>
    .bottom-1-text{
        margin-left: 20rem;
        // &::before{
        //     content:url(../static/ellipsis.png);
        //     transform: scale(var(--size), var(--size));
        //     position: absolute;
        //     left: 4rem;
        //     top: calc(-50% + 14rem);
        // }
    }


    .el-icon-sunrise {
        background: url('../static/ellipsis.png') center center no-repeat;
        transform: scale(1.2,1.2);
        background-size: 11rem;
    }
    
    .el-icon-sunrise:before {
        content: "11";
        visibility: hidden;
    }


    .bottom-1-span{
        border: none;
        background: none;
        padding: 0;
        margin: 0;
        &:hover{
            background: none;
            border: none;
            color: #666666;
        }
        div{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // .el-popper {
    //     overflow: auto; 
    // }
    // .el-dropdown-menu{
    //     overflow: hidden;
    // }
    .el-dropdown-menu__item:hover {
        background-color: #e9e9ea;
    }
    .el-dropdown-menu__item {
        // width: 160rem;
    }
</style>
